import axiosInstance from "../../translator";
import { myLabs } from "../../constants/apis/apiEndpoints";

export const fetchmyLabsList = async (urlParams) => {
  return axiosInstance
    .get(`${myLabs?.labsList}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const myLabFeatures = async (urlParams, bodyData) => {
  return axiosInstance
    .patch(`${urlParams}`, bodyData)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const updateRating = async (bodyData, id) => {
  return axiosInstance
    .patch(`${myLabs.labRating}/${id}`, bodyData)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const myLabsConnectApi = async (id, payload) => {
  return axiosInstance
    .post(`${myLabs.vmOperations}/${id}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const myLabExtsnVldtyGetApi = async ({ params }) => {
  return axiosInstance
    .get(`${myLabs.extension}`, { params })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const myLabExtsnVldtyUpdateApi = async (data) => {
  return axiosInstance
    .post(`${myLabs.extsnUpdate}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const myLabVMAuthConnectApi = async (data) => {
  return axiosInstance
    .get(`${myLabs.vmAuthConnect}/${data?.vm_id}?stage=5`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const myLabVmConnectReadinessApi = async (data) => {
  return axiosInstance
    .get(`${myLabs.vmAuthConnect}/${data?.vm_id}?stage=${data?.step}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const myLabVmConnectPoolReadinessApi = async (data) => {
  return axiosInstance
    .get(`${myLabs.vmPoolConnect}${data?.params}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const myLabPooledVmDuration = async (data) => {
  return axiosInstance
    .get(`${myLabs.vmDuration}/${data}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const vmDetailsApi = async (payload) => {
  return axiosInstance
    .get(`${myLabs.vmDetails}/${payload}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const addVmDurationApi = async (data) => {
  return axiosInstance
    .post(`${myLabs.vmAddOn}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getLabInstructions = async (bodyData) => {
  return axiosInstance
    .get(`${myLabs.lab_instructions}`, { params: bodyData })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getInstanceSizeListApi = async (data) => {
  return axiosInstance
    .get(`${myLabs.instance_size_list}/${data?.tenant_id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const reconfigureVmApi = async (data) => {
  return axiosInstance
    .post(`${myLabs.reconfigure_vm}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const reprovisionLabApi = async (data) => {
  return axiosInstance
    .post(`${myLabs.reprovision_lab}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const vmStateManageApi = async (data) => {
  const { id, vm_state } = data;
  const url = `${myLabs.vmStateManageURL}/${id}?vm_state=${vm_state}`;
  return axiosInstance
    .get(url)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const manageVMExportApi = async (params) => {
  return axiosInstance
    .get(`${myLabs.labsList}`, { params: params })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const restoreVMApi = async (data) => {
  return axiosInstance
    .post(`${myLabs.restoreVmApiUrl}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};